import React from "react";
import "./videos.css";

function Videos() {
    return(
        <div className="videosContainer">
            <div className="topLine">
                <h3>
                    Watch the creative process
                </h3>
            </div>
            <div className="descriptionContent">
                <div className="description">
                    When you order custom artwork, you will receive a DVD that shows the process of your piece being created. It will look similar to this example:
                </div>
            </div>
            <div className="videoBox">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/OQKfZ-2ekxo?rel=0&fs=1&modestbranding=1" title="Bingham Inlay Arts" frameborder="0" allow="fullscreen" allowfullscreen></iframe>
            </div>
            <div className="videoBox">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/qYkWjz8NK24?rel=0&fs=1&modestbranding=1" title="Bingham Inlay Arts" frameborder="0" allow="fullscreen" allowfullscreen></iframe>
            </div>
            <div className="descriptionContent">
                <div className="description">
                    Have your boat or home transformed into marquetry!
                </div>
            </div>
            <div className="videoBox">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/tnb3ASa-KMA?rel=0&fs=1&modestbranding=1" title="Bingham Inlay Arts" frameborder="0" allow="fullscreen" allowfullscreen></iframe>
            </div>
            <div className="descriptionContent">
                <div className="description">
                    Time lapse video showing knife cutting a single part at 2.5 times normal speed.
                </div>
            </div>
            <div className="videoBox">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/vUvH5AMyWpg?rel=0&fs=1&modestbranding=1" title="Bingham Inlay Arts" frameborder="0" allow="fullscreen" allowfullscreen></iframe>
            </div>
            <div className="descriptionContent">
                <div className="description">
                    Here is an extra example of the magic of applying the first coat of finish...
                </div>
            </div>
            <div className="videoBox">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/FsbJEpSR2jI?rel=0&fs=1&modestbranding=1" title="Bingham Inlay Arts" frameborder="0" allow="fullscreen" allowfullscreen></iframe>
            </div>
            <div className="descriptionContent">
                <div className="description">
                    Here is a progress video of an english inn created in marquetry.
                </div>
            </div>
            <div className="videoBox">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/d993Ruxy9mM?rel=0&fs=1&modestbranding=1" title="Bingham Inlay Arts" frameborder="0" allow="fullscreen" allowfullscreen></iframe>
            </div>
            <div className="descriptionContent">
                <div className="description">
                    This was a wedding present. It is the chapel they were married in.
                </div>
            </div>



            <div className="videoBox">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/ZDAUcuo35Ag?rel=0&fs=1&modestbranding=1" title="Bingham Inlay Arts" frameborder="0" allow="fullscreen" allowfullscreen></iframe>
            </div>
            <div>
                <h5>
                    Here are several 'first coat of finish' videos:
                </h5>
            </div>
            <div className="videoBox">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/2FXnGhgNhiY?rel=0&fs=1&modestbranding=1" title="Bingham Inlay Arts" frameborder="0" allow="fullscreen" allowfullscreen></iframe>
            </div>
            <div className="videoBox">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/G67FeJnfXy8?rel=0&fs=1&modestbranding=1" title="Bingham Inlay Arts" frameborder="0" allow="fullscreen" allowfullscreen></iframe>
            </div>
            <div className="videoBox">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/1l1d8lpYmPo?rel=0&fs=1&modestbranding=1" title="Bingham Inlay Arts" frameborder="0" allow="fullscreen" allowfullscreen></iframe>
            </div>
            <div className="videoBox">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/CiNsYne0bss?rel=0&fs=1&modestbranding=1" title="Bingham Inlay Arts" frameborder="0" allow="fullscreen" allowfullscreen></iframe>
            </div>
            <div className="videoBox">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/I04_FTIX4Eo?rel=0&fs=1&modestbranding=1" title="Bingham Inlay Arts" frameborder="0" allow="fullscreen" allowfullscreen></iframe>
            </div>
            <div className="videoBox">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/tnb3ASa-KMA?rel=0&fs=1&modestbranding=1" title="Bingham Inlay Arts" frameborder="0" allow="fullscreen" allowfullscreen></iframe>
            </div>
            <div className="videoBox">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/NjIP-glCo3k?rel=0&fs=1&modestbranding=1" title="Bingham Inlay Arts" frameborder="0" allow="fullscreen" allowfullscreen></iframe>
            </div>
            <div className="videoBox">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/uB7Eg__XH-M?rel=0&fs=1&modestbranding=1" title="Bingham Inlay Arts" frameborder="0" allow="fullscreen" allowfullscreen></iframe>
            </div>
            <div className="videoBox">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/7qq9z_iI9G8?rel=0&fs=1&modestbranding=1" title="Bingham Inlay Arts" frameborder="0" allow="fullscreen" allowfullscreen></iframe>
            </div>
            <div className="descriptionContent">
                <div className="description">
                    More videos to come...
                </div>
            </div>
        </div>
    );
};

export default Videos;